package kz.dentalcrm.app.screens.dialogs

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import compose.icons.FeatherIcons
import compose.icons.feathericons.HelpCircle
import compose.icons.feathericons.MessageCircle
import compose.icons.feathericons.Phone
import compose.icons.feathericons.Send
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.answer_to_whats_app
import dentalcrm.composeapp.generated.resources.call_by_phone
import dentalcrm.composeapp.generated.resources.choose_reply_action
import dentalcrm.composeapp.generated.resources.reply_by_template
import kz.dentalcrm.app.core.ui.components.ContentButton
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PhoneActionDialog(
    phone: String,
    onDismissRequest: () -> Unit,
    onCall: (phone: String) -> Unit,
    onWhatsapp: (phone: String) -> Unit,
    onSend: () -> Unit
) {

    ModalBottomSheet(
        containerColor = DefaultTheme.colors.surface,
        onDismissRequest = onDismissRequest
    ) {
        LazyColumn(
            modifier = Modifier.fillMaxWidth()
        ) {
            item {
                Spacer(modifier = Modifier.height(24.dp))
                Text(
                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                    text = stringResource(Res.string.choose_reply_action),
                    style = DefaultTheme.typography.subHeading1,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(16.dp))
            }
            item {
                ContentButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    shape = RoundedCornerShape(16.dp),
                    onClick = {
                        onCall(phone)
                    }
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(56.dp)
                            .clip(shape = RoundedCornerShape(16.dp))
                            .padding(horizontal = 16.dp, vertical = 4.dp),
                        verticalArrangement = Arrangement.Center
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Box(
                                modifier = Modifier.size(40.dp)
                                    .background(
                                        color = DefaultTheme.colors.primarySubdued,
                                        shape = RoundedCornerShape(40.dp)
                                    ),
                                contentAlignment = Alignment.Center
                            ) {
                                Icon(
                                    imageVector = FeatherIcons.Phone,
                                    contentDescription = "Icon",
                                    tint = DefaultTheme.colors.onSurface.copy(
                                        0.8f
                                    ),
                                    modifier = Modifier.size(24.dp)
                                )
                            }
                            Spacer(modifier = Modifier.width(16.dp))
                            Text(
                                text = stringResource(Res.string.call_by_phone),
                                style = DefaultTheme.typography.bodyMediumMedium,
                                fontWeight = FontWeight.Medium,
                                color = DefaultTheme.colors.onSurface
                            )
                            Spacer(modifier = Modifier.width(16.dp))
                        }
                    }
                    Spacer(modifier = Modifier.height(8.dp))
                    Box(
                        modifier = Modifier.height(0.5.dp).fillMaxWidth()
                            .background(
                                color = DefaultTheme.colors.primary.copy(
                                    alpha = 0.5f
                                )
                            )
                            .padding(horizontal = 16.dp)
                    )
                    Spacer(modifier = Modifier.height(8.dp))
                }
            }
            item {
                ContentButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    shape = RoundedCornerShape(16.dp),
                    onClick = {
                        onWhatsapp(phone)
                    }
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(56.dp)
                            .clip(shape = RoundedCornerShape(16.dp))
                            .padding(horizontal = 16.dp, vertical = 4.dp),
                        verticalArrangement = Arrangement.Center
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Box(
                                modifier = Modifier.size(40.dp)
                                    .background(
                                        color = DefaultTheme.colors.primarySubdued,
                                        shape = RoundedCornerShape(40.dp)
                                    ),
                                contentAlignment = Alignment.Center
                            ) {
                                Icon(
                                    imageVector = FeatherIcons.MessageCircle,
                                    contentDescription = "Icon",
                                    tint = DefaultTheme.colors.onSurface.copy(
                                        alpha = 0.8f
                                    ),
                                    modifier = Modifier.size(24.dp)
                                )
                            }
                            Spacer(modifier = Modifier.width(16.dp))
                            Text(
                                text = stringResource(Res.string.answer_to_whats_app),
                                style = DefaultTheme.typography.bodyMediumMedium,
                                fontWeight = FontWeight.Medium,
                                color = DefaultTheme.colors.onSurface
                            )
                            Spacer(modifier = Modifier.width(16.dp))
                        }
                    }
                }
            }
            item {
                ContentButton(
                    modifier = Modifier
                        .fillMaxWidth(),
                    shape = RoundedCornerShape(16.dp),
                    onClick = {
                        onSend()
                    }
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(56.dp)
                            .clip(shape = RoundedCornerShape(16.dp))
                            .padding(horizontal = 16.dp, vertical = 4.dp),
                        verticalArrangement = Arrangement.Center
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            Box(
                                modifier = Modifier.size(40.dp)
                                    .background(
                                        color = DefaultTheme.colors.primarySubdued,
                                        shape = RoundedCornerShape(40.dp)
                                    ),
                                contentAlignment = Alignment.Center
                            ) {
                                Icon(
                                    imageVector = FeatherIcons.HelpCircle,
                                    contentDescription = "Icon",
                                    tint = DefaultTheme.colors.onSurface.copy(
                                        alpha = 0.8f
                                    ),
                                    modifier = Modifier.size(24.dp)
                                )
                            }
                            Spacer(modifier = Modifier.width(16.dp))
                            Text(
                                text = stringResource(Res.string.reply_by_template),
                                style = DefaultTheme.typography.bodyMediumMedium,
                                fontWeight = FontWeight.Medium,
                                color = DefaultTheme.colors.onSurface
                            )
                            Spacer(modifier = Modifier.width(16.dp))
                        }
                    }
                }
            }
            item {
                Spacer(modifier = Modifier.height(56.dp))
            }
        }
    }
}
